<div class="main-page-content">
  <div class="main-page-content-block">

    <h1 class="content-heading-font">{{ currentClient?.BusinessName ||'Client' }} Companies</h1>
    <p *ngIf="loading" role="status">Loading companies...</p>
    <p *ngIf="!loading && !companies.length">No company information is available.</p>

    <ng-container *ngIf="currentItem">
      <div class="row">
        <div class="col-12">
            <label for="company">Company</label>
            <select id="company" class="form-select mb-3" [ngModel]="currentItem.ID" 
                    (ngModelChange)="selectCompany($event)" [disabled]="saving">
              <option *ngFor="let company of companies" [ngValue]="company.ID">
                {{company.BusinessName}} {{company.IsMain ? '(Main)' : ''}}
              </option>
            </select>
        </div>
      </div>
     
      <form [formGroup]="itemFormGroup" (ngSubmit)="save()">
        <fieldset [disabled]="saving">
          <div class="row">
            <div class="col-12 col-md-6 mb-3" *ngFor="let field of fields">
              <label [for]="field.name">{{field.label}} {{field.required ? '*' : ''}}</label>
              <input class="form-control" [id]="field.name" [type]="field.type" [formControlName]="field.name"
                     [attr.maxlength]="field.max" [attr.step]="field.type === 'number' ? 'any' : null"
                     [class.is-invalid]="itemFormGroup.get(field.name)?.touched && itemFormGroup.get(field.name)?.invalid" autocomplete="off" />
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label for="IsMain">Is Main Company</label>
              <select id="IsMain" class="form-select" formControlName="IsMain" *ngIf="currentItem?.IsMain===false">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <input class="form-control" id="IsMain" type="text"  *ngIf="currentItem?.IsMain===true"
                     readonly="readonly" value="Yes"  />
            </div>
          </div>
          <div class="row">
            <div class="col text-center">
              <button type="submit" class="btn btn-success" [class.button-loading]="saving" [disabled]="saving">Save Company</button>
            </div>
          </div>

          
        </fieldset>
      </form>

    </ng-container>
  </div>
</div>
